<template>
  <div class="users">
    <Management
      :title="$t('user.name-plural')"
      :fields="fields"
      :data="users"
      :loading="loading"
      sort="lastname"
      inspect-route="/profile/"
      create-route="/user-creation"
    ></Management>
  </div>
</template>

<script>
import Management from "@/components/utilities/Management";
import adaptersOut from "@/services/data-adapter/incoming/user";

export default {
  components: {
    Management
  },
  data() {
    return {
      loading: true,
      users: []
    };
  },
  computed: {
    fields() {
      return [
        {
          name: "firstname",
          text: this.$t("user.fields.firstname"),
          sortable: true
        },
        {
          name: "lastname",
          text: this.$t("user.fields.lastname"),
          sortable: true
        },
        {
          name: "email",
          text: this.$t("user.fields.email"),
          sortable: true
        },
        {
          name: "role",
          text: this.$t("user.fields.role"),
          sortable: true
        }
      ];
    }
  },
  mounted: function() {
    this.$nextTick(function() {
      this.getUsers();
    });
  },
  methods: {
    getUsers() {
      var self = this;
      this.loading = true;

      var requestSuccessful = function(req) {
        if (!req.data.users) {
          return;
        }
        adaptersOut.users(req.data.users).then(res => {
          self.users = res;
          self.users.forEach((user, i, arr) => {
            arr[i].role = arr[i].role
              ? self.$t("user.roles." + arr[i].role + ".title")
              : self.$t("user.roles.undefined");
          });
          self.loading = false;
        });
      };

      var requestFailed = function() {
        if (self.users) {
          self.users = [];
        }
        self.$store.dispatch(
          "system/setStatus",
          {
            type: "error",
            message: "Could not retrieve users information."
          },
          { root: true }
        );
      };

      return this.$http
        .get("/users?trashed=1")
        .then(request => requestSuccessful(request))
        .catch(error => requestFailed(error));
    }
  }
};
</script>
